import {
    ICategory, IContact,
    IStatus,
} from '@/interfaces';
import { ContactsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setStatuses(state: ContactsState, payload: IStatus[]) {
        state.statuses = payload;
    },
    setCategories(state: ContactsState, payload: ICategory[]) {
        state.categories = payload;
    },
    setContacts(state: ContactsState, payload: IContact[]) {
        state.contacts = payload;
    },
};

const {commit} = getStoreAccessors<ContactsState | any, State>('');

export const commitSetStatuses = commit(mutations.setStatuses);
export const commitSetCategories = commit(mutations.setCategories);
export const commitSetContacts = commit(mutations.setContacts);
